export const TEST_ID = 'confirmationModal';
